<template>
  <default-textual-section v-if="$store.state.displayType === 'textual'" :menu="menu" :section="section"
                           :section-modifier="sectionModifier"
                           menu-item-component="back-bar-default-item"
                           class="menu--section-back_bar"></default-textual-section>
  <default-visual-section v-else :menu="menu" :section="section"
                          :section-modifier="sectionModifier"
                          menu-item-component="back-bar-default-item"
                          class="menu--section-back_bar"></default-visual-section>
</template>

<script lang="ts">
/**
 * Custom component for Back Bar default menu sections.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 2.0.0
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *  2023-12-19 (1.0.0) (jhoward)
 *    - Copy from <WvSteakHouseDefaultSection> component to <back-bar-default-section> component.
 *
 *  2025-02-11 (1.1.0) (jhoward)
 *    - Add <menu-schedules> to the <back-bar-default-section> component if in admin view.
 *
 *  2025-04-08 (2.0.0) (jhoward)
 *    - Use <default-textual-section> and <default-visual-section> in <back-bar-default-section>.
 *    - Add textual and visual menu CSS tweaks to <back-bar-default-section>.
. */

import {defineComponent, PropType} from "vue";
import {Menu, MenuSection} from "../defs";
import DefaultVisualSection from "./visual/defaultVisualSection.vue";
import DefaultTextualSection from "./textual/defaultTextualSection.vue";

export default defineComponent({
  components: {
    DefaultTextualSection,
    DefaultVisualSection,
  },
  name: "BackBarDefaultSection",
  props: {
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    sectionModifier: {
      type: String,
      default: ''
    },
  },
})
</script>

<style>
.textual_menu--container-back_bar h1 {
  color: #000000;
  font-family: american-captain, serif;
  display: none;
}

.textual_menu--container-back_bar .textual_menu--section h1 {
  display: initial;
}

.textual_menu--container-back_bar .page-link-group-copy {
  text-align: center;
}

.visual_menu--container-back_bar .visual_menu--page,
.textual_menu--container-back_bar {
  background-image: url('/library/images/menu/backgroud-back-bar.jpg');
  background-repeat: repeat;
  background-color: #fef9e8;
}

.visual_menu--container-back_bar .visual_menu--page.visual_menu--content_top .visual_menu--section,
.visual_menu--container-landscape.visual_menu--container-back_bar .visual_menu--page.visual_menu--content_top .visual_menu--section {
  padding-top: 3em;
  padding-bottom: 0;
  text-align: center;
}

.visual_menu--container-back_bar .visual_menu--page.visual_menu--content_top .visual_menu--section p {
  margin: 0;
}

.visual_menu--container-back_bar .visual_menu--page.visual_menu--content_top + .visual_menu--page .visual_menu--section {
  padding-top: 0;
}

.visual_menu--container-back_bar .visual_menu--page.visual_menu--content_top + .visual_menu--page .menu--section_title {
  margin-top: 0;
}

.menu--container-back_bar .back-bar-logo {
  width: 70%;
  margin-left: -10%;
}
</style>

<style scoped>
@font-face {
  font-family: 'american-captain';
  src: url('/library/fonts/American-Captain.otf') format('opentype');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'muchacho';
  src: url('/library/fonts/Muchacho.woff2') format('woff2');
  font-weight: 400;
  font-style: normal;
}

.textual_menu--section-back_bar {
  font-size: 1.2em;
}

.menu--section-back_bar:deep(.menu--section_title) {
  color: #000000;
  font-size: 1.8em !important;
  font-family: american-captain, serif;
  padding: 0 2em 0 2em;
}

.menu--section-back_bar:deep(.menu--section_subtitle) {
  font-family: muchacho, serif;
  text-align: center;
  font-size: 0.8em;
}

.menu--section-back_bar,
.visual_menu--container-landscape .menu--section-back_bar {
  padding-top: 4em;
  padding-bottom: 6em;
}

.visual_menu--page:not(.visual_menu--content_top) + .visual_menu--page .menu--section-back_bar::before,
.visual_menu--page:not(.visual_menu--content_top) + .visual_menu--page .menu--section-back_bar::after,
.textual_menu--section + .textual_menu--section::before,
.textual_menu--section + .textual_menu--section::after {
  content: '';
  position: absolute;
  top: 0.5em;
  left: 0;
  width: 100%;
  height: 3em;
  background-image: url('/library/images/menu/back-bar-header.png');
  background-repeat: no-repeat;
  background-position: 50% 0;
  background-size: 100% auto;
}

.visual_menu--page:not(.visual_menu--content_top) + .visual_menu--page .menu--section-back_bar::after,
.textual_menu--section + .textual_menu--section::after {
  top: auto;
  bottom: 0.5em;
  background-position: 50% 100%;
  background-image: url('/library/images/menu/back-bar-footer.png');
}
</style>